module.exports = __webpack_public_path__ + "static/media/Download_App_Store.e841bf17.svg";